<button class="dropdown-button" [class.active]="isActive" (click)="onDropdownClick()">
  {{ label }}
  <i class="icon icon-arrow-down-more-red"></i>
</button>
